import Vue from 'vue'
import App from './App.vue'
import router from './router'
import  './router/router-ctrl.js'
import store from './store'
import './ss.scss'

Vue.config.productionTip = false

import ssModal from '@/components/ss-modal/ss-modal.vue'
import ssBreadcrumb from '@/components/ss-breadcrumb/ss-breadcrumb.vue'
import ssNavigation from '@/components/ss-navigation/ss-navigation.vue'
import ssRecmdList from '@/components/ss-recmd-list/ss-recmd-list.vue'
import ssNoData from '@/components/ss-no-data/ss-no-data.vue'

// 模态框
Vue.component('ssModal', ssModal)
// 面包屑
Vue.component('ssBreadcrumb', ssBreadcrumb)
// 分页器
Vue.component('ssNavigation', ssNavigation)
// 推荐列表
Vue.component('ssRecmdList', ssRecmdList)
// 暂无列表
Vue.component('ssNoData', ssNoData)

import 'vue2-toast/lib/toast.css';
import Toast from 'vue2-toast';
Vue.use(Toast, {
    type: 'top',
    duration: 2000,
    wordWrap: true
});

// 图片查看器
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
Viewer.setDefaults({
  Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})

Vue.prototype.$hideLoading = function() {
	Vue.prototype.$loading.close()
};

// 注入全局的公共方法
import globalMethods from '@/mixins/globalMethods.js' 
Object.keys(globalMethods).forEach(mKey => {
	Vue.prototype[mKey] = globalMethods[mKey];
})

// 注入全局的过滤器
import filters from '@/filters'
Object.keys(filters).forEach(fKey => {
  Vue.filter(fKey, filters[fKey])
})

import VuejsDialog from 'vuejs-dialog';
import VuejsDialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js'; // only needed in custom components
// include the default style
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
 
Vue.use(VuejsDialog)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
